export function formatDateTime(date, format = 'date') {
    let dateTime;

    if (typeof date === 'string') {
        dateTime = new Date(date);
    } else {
        dateTime = date;
    }
    let options  = {};
    switch (format) {
        case 'date':
            options = {day: '2-digit', month: 'long', year: 'numeric'};
            break;
        case 'time':
            options = {hour: 'numeric', minute: 'numeric'};
            break;
        case 'month year':
            options = {month: 'long', year: 'numeric'};
            break;
        case 'year':
            options = {year: 'numeric'};
            break;
        default:
            options = {day: '2-digit', month: 'long', year: 'numeric'};

    }


    return new Intl.DateTimeFormat('fr-FR', options).format(dateTime);
}